import { Component, HostBinding, Input, OnInit } from '@angular/core';

@Component({
  selector: 'lib-ags-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent implements OnInit {
  @HostBinding('class') themeFlag: string;
  @Input() themingClassName;

  ngOnInit() {
    this.themeFlag = `${this.themeFlag || ''} ${this.themingClassName}`;
  }
}
